const formListConstants = {
  INITIALIZE_FORM_LIST: 'INITIALIZE_FORM_LIST',
  INITIALIZE_FORM_LIST_SUCCESS: 'INITIALIZE_FORM_LIST_SUCCESS',
  INITIALIZE_FORM_LIST_ERROR: 'INITIALIZE_FORM_LIST_ERROR',
  CREATE_FORM: 'CREATE_FORM',
  CREATE_FORM_SUCCESS: 'CREATE_FORM_SUCCESS',
  CREATE_FORM_ERROR: 'CREATE_FORM_ERROR',
  CLEAR_NEW_FORMID: 'CLEAR_NEW_FORMID'
};

export default formListConstants;
